import React from "react";
import injectSheet from "react-jss";
import { BudgetOverview, TextButton } from "../../";

const BottomNavProcess = (props) => {
  const {
    budget,
    classes,
    currentPath,
    goBack,
    history,
    next,
    reconfigure,
    siblings,
  } = props;

  const handleNext = () => {
    if (siblings.next) {
      return history.push(`/${currentPath[0]}/${siblings.next}`);
    }
    if (next.finished) {
      reconfigure();
      window.location.reload();
    }
    return history.push(`/${next.path}`);
  };

  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.navContainer}`}>
        <div className={`${classes.buttonContainer}`}>
          <TextButton
            index={100}
            handleClick={() => goBack()}
            primary={false}
            text="zurück"
          />
        </div>
        <div className={`${classes.fullWidth}`}>
          {budget && <BudgetOverview />}
      <p className={`${classes.contact}`}>
        {"Fragen? "}
        <a
          href="mailto:info@hausconcept.ch"
          className={`${classes.contactLink}`}
        >
          {"info@hausconcept.ch "}
        </a>
        {" oder "}
        <a href="tel:+41419222055" className={`${classes.contactLink}`}>
          041 922 20 55
        </a>
      </p>
        </div>
        <div className={`${classes.buttonContainer}`}>
          <TextButton
            disabled={!siblings.next && !next}
            index={101}
            handleClick={() => handleNext()}
            primary
            text={next.button ? next.button : "weiter"}
          />
        </div>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  contact: {
    fontSize: "0.675em",
  },
  contactLink: {
    color: theme.colors.main_1,
    textDecoration: "none",
    "&:hover": {
      color: theme.colors.main_3,
    },
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    fontSize: "60%",
    [theme.media.medium]: {
      fontSize: "100%",
    },
  },
  buttonContainer: {
    flexGrow: 0,
    [theme.media.medium]: {
      marginBottom: 0,
    },
  },
  fullWidth: {
    width: "100%",
    textAlign: "center",
  },
  statusContainer: {
    display: "none",
    flexGrow: 1,
    opacity: 0,
    marginBottom: `${theme.sizes.gutter / 2}px`,
    [theme.media.medium]: {
      display: "block",
    },
    transition: [
      {
        property: "opacity",
        duration: theme.speed.medium,
        delay: theme.speed.fast,
        timingFunction: theme.motion.deceleration,
      },
    ],
    "&.withProgress": {
      opacity: 1,
    },
  },
});

export default injectSheet(styles)(BottomNavProcess);



// WEBPACK FOOTER //
// ./src/modules/core/components/bottomNavProcess.jsx